import { render, staticRenderFns } from "./ZiliaoAdd.vue?vue&type=template&id=36db657c&scoped=true"
import script from "./ZiliaoAdd.vue?vue&type=script&lang=js"
export * from "./ZiliaoAdd.vue?vue&type=script&lang=js"
import style0 from "./ZiliaoAdd.vue?vue&type=style&index=0&id=36db657c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36db657c",
  null
  
)

export default component.exports